export const nameRoutes = {
  LOGIN: "Login",
  RESET: "Reset",
  HOME: "Home",
  BENVENUTO: "Benvenuto",
  RICHIESTE: "Richieste",
  RICHIESTA: "Richiesta",
  PORTATA: "Portata",
};
